import { useEffect, useState } from "react";

import { Box, Stack, Typography } from "@mui/material";

import CustomButton from "../../../../helper-components/input/CustomButton";
import { getPatientDisplayName } from "../../../../helper-functions/shared/patientDisplay";
import { querySimilarPatients } from "../../../../helper-functions/api/patientQueries";

const formatBirthDate = (value) => {
    if (!value) return "no birth date";
    return String(value).substring(0, 10);
};

/**
 * Lists patients whose names are close enough to be the same person entered twice.
 */
export default function SimilarPatientsDialog(props) {
    const [groups, setGroups] = useState(null);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        querySimilarPatients(props, (result) => {
            if (!Array.isArray(result)) {
                setFailed(true);
                setGroups([]);
                return;
            }
            setGroups(result);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const openPatient = (patientId) => {
        props.setOpenDialog(false);
        props.browser.navigate(`/database/patients/${patientId}`);
    };

    if (groups === null) {
        return (
            <Box sx={{ p: 2 }}>
                <Typography>Looking through patient names...</Typography>
            </Box>
        );
    }

    if (failed) {
        return (
            <Box sx={{ p: 2 }}>
                <Typography>Could not check patient names. Try again in a moment.</Typography>
            </Box>
        );
    }

    if (groups.length === 0) {
        return (
            <Box sx={{ p: 2 }}>
                <Typography>No similar names found. Names need to match about 75%, ignoring capitals and spaces.</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ p: 1, maxHeight: "60vh", overflow: "auto" }}>
            <Typography variant="body2" sx={{ mb: 2 }}>
                Checked every patient. Each percentage is that pair's full first and last name, ignoring capitals and spaces.
            </Typography>
            <Stack spacing={2}>
                {groups.map((group) => (
                    <Box key={group.patients.map((patient) => patient.id).join("-")} sx={{ border: 1, borderColor: "divider", borderRadius: 1, p: 1.5 }}>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            {Math.round((group.similarity || 0) * 100)}% similar
                        </Typography>
                        <Stack spacing={0.5}>
                            {group.patients.map((patient) => (
                                <Stack key={patient.id} direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                                    <Typography variant="body2">
                                        {getPatientDisplayName(patient)} · {formatBirthDate(patient.birth_date)}
                                    </Typography>
                                    <CustomButton {...props} title="Open" size="small" onClick={() => openPatient(patient.id)} />
                                </Stack>
                            ))}
                        </Stack>
                    </Box>
                ))}
            </Stack>
        </Box>
    );
}
